import React, { FC } from 'react';
import { Backdrop, Grid } from '@material-ui/core';
import { useStyles } from './style';
import { SpinnerIcon } from '../CustomIcons';
import { useLoading } from '../../providers';

export const Spinner: FC = () => {
  const classes = useStyles();
  const { isLoading } = useLoading();

  return (
    <Backdrop className={classes.backdrop} open={isLoading}>
      <Grid container direction="column" alignItems="center">
        <SpinnerIcon className={classes.rotateIcon} />
      </Grid>
    </Backdrop>
  );
};
